export const PRODUCT_DEFAULT_SORT = "search.score() desc, sku_ asc";
